import { BaseCRUD } from '@/services/base-request';
import { toastSuccess, toastError } from '@/composables/toast';

const serviceName = 'games';

export class CategoriesService {
    /**
     * @param {number} offset
     * @param {number} limit
     * @returns {Promise<Response>}
     */
    static async getCategoriesList (offset, limit) {
        const resp = await BaseCRUD.GET({
            service: serviceName,
            entity: 'categories',
            query: {
                offset,
                limit,
            },
        });

        if (!resp.status.ok) {
            toastError('serverError');
            return null;
        }
        return resp.payload;
    };

    /**
     * @param {string} id
     * @returns {Promise<Response>}
     */
    static async getCategoryById (id) {
        const resp = await BaseCRUD.GET({
            service: serviceName,
            entity: 'categories',
            id,
        });

        if (!resp.status.ok) {
            toastError('serverError');
            return null;
        }
        return resp.payload;
    };

    /**
     * @param {string} id
     * @param {object} body
     * @returns {Promise<Response>}
     */
    static async changeCategoryInfo (id, body) {
        const resp = await BaseCRUD.PATCH({
            service: serviceName,
            entity: 'categories',
            id,
            body,
        });

        if (!resp.status.ok) {
            toastError('serverError');
            return null;
        }
        return resp.status.ok;
    };

    /**
     * @param {string} id
     * @returns {Promise<Response>}
     */
    static async getGamesInCategory (id) {
        const resp = await BaseCRUD.GET({
            service: serviceName,
            entity: `categories/${id}/games`,
        });

        if (!resp.status.ok) {
            toastError('serverError');
            return null;
        }
        return resp.payload;
    };

    /**
     * @param {string} categoryId
     * @param {string} gameId
     * @returns {Promise<Response>}
     */
    static async addGamesToCategory (categoryId, gameId) {
        const resp = await BaseCRUD.POST({
            service: serviceName,
            entity: `categories/${categoryId}/games`,
            body: {
                gameId,
            },
        });

        if (!resp.status.ok) {
            toastError('serverError');
            return null;
        }
        return resp.status.ok;
    };

    /**
     * @param {string} categoryId
     * @param {string} gameId
     * @returns {Promise<Response>}
     */
    static async removeGamesFromCategory (categoryId, gameId) {
        const resp = await BaseCRUD.DELETE({
            service: serviceName,
            entity: 'categories',
            id: `${categoryId}/games/${gameId}`,
        });

        if (!resp.status.ok) {
            toastError('serverError');
            return null;
        }
        return resp.status.ok;
    };

    /**
     * @param {string} id
     * @param {object} body
     * @returns {Promise<Response>}
     */
    static async updateGamesInCategory (id, body) {
        const resp = await BaseCRUD.PUT({
            service: serviceName,
            entity: `categories`,
            id: `${id}/games`,
            body,
        });

        if (!resp.status.ok) {
            toastError('serverError');
            return null;
        }
        return resp.status.ok;
    };

    /**
     * @param {object} body
     * @param {string} body.name required
     * @param {string} body.designStyle
     * @returns {Promise<Response>}
     */
    static async createCategory (body) {
        const resp = await BaseCRUD.POST({
            service: serviceName,
            entity: 'categories',
            body,
        });

        if (!resp.status.ok) {
            toastError('serverError');
            return null;
        }
        toastSuccess('categoryCreated');
        return resp.payload;
    };

    /**
     * @param {string} id
     * @returns {Promise<Response>}
     */
    static async deleteCategory (id) {
        const resp = await BaseCRUD.DELETE({
            service: serviceName,
            entity: 'categories',
            id,
        });

        if (!resp.status.ok) {
            toastError('serverError');
            return null;
        }
        toastSuccess('categoryDeleted');
        return resp.status.ok;
    };
}
